import type { PalavraCanonica } from '../tipos';

/**
 * Fila de novidade (§4.2).
 *
 * Guarda as últimas 40 sugestões exibidas para evitar repetição próxima.
 * Quando uma letra esgota as opções fora da fila, a restrição é relaxada
 * **da mais antiga para a mais recente** — por isso a fila é ordenada, e não
 * um simples conjunto.
 *
 * A fila faz parte do estado persistido (§12): sem ela, recarregar a página
 * mudaria a ordem das sugestões e quebraria a reprodutibilidade exigida em §10.
 */

export const CAPACIDADE_NOVIDADE = 40;

export interface FilaNovidade {
  /** Da mais antiga para a mais recente. */
  readonly itens: readonly PalavraCanonica[];
}

export const FILA_VAZIA: FilaNovidade = { itens: [] };

export function registrar(fila: FilaNovidade, palavra: PalavraCanonica): FilaNovidade {
  const semDuplicata = fila.itens.filter((item) => item !== palavra);
  const proximos = [...semDuplicata, palavra];
  const excedente = proximos.length - CAPACIDADE_NOVIDADE;
  return { itens: excedente > 0 ? proximos.slice(excedente) : proximos };
}

export function contem(fila: FilaNovidade, palavra: PalavraCanonica): boolean {
  return fila.itens.includes(palavra);
}

/**
 * Idade na fila: `0` é a mais antiga. Devolve `Infinity` para palavras
 * ausentes, que por isso ordenam antes de qualquer palavra recente.
 */
export function idadeDe(fila: FilaNovidade, palavra: PalavraCanonica): number {
  const i = fila.itens.indexOf(palavra);
  return i === -1 ? Number.POSITIVE_INFINITY : i;
}

export function restaurarFila(itens: readonly string[]): FilaNovidade {
  const limitado = itens.slice(-CAPACIDADE_NOVIDADE) as PalavraCanonica[];
  return { itens: limitado };
}
